import styled, { css } from 'styled-components';

import { colors } from 'theme/colors';

export const Button = styled.button`
  min-width: 80px;
  width: 100%;
  height: 48px;
  font-family: inherit;
  font-size: ${props => props.theme.styles.submitButton.fontSize};
  font-weight: 700;
  text-shadow: none;
  line-height: ${props => props.theme.styles.submitButton.lineHeight};
  margin: ${props => props.theme.styles.submitButton.margin};
  border-radius: 0.5rem;
  box-shadow: none;
  transition: all 0.3s ease 0s;
  padding: 10px 0;
  color: ${colors['content-inverse']};
  background-color: ${colors['bg-action-primary']};
  border: none;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => css`
    ${props.theme.media.desktop`
        max-width: none;
      `};
  `};

  &:hover,
  &:focus {
    outline: none;
    background-color: ${colors['bg-action-primary-hover']};
  }
  &:active {
    outline: none;
    background-color: ${colors['accent-green400']};
  }

  ${props =>
    props.disabled &&
    css`
      color: ${colors['disabled-primary']};
      background-color: ${colors['bg-tertiary']};
      pointer-events: none;
    `};

  ${props =>
    props.isStickySubmitButton &&
    css`
      margin-top: 0;
    `}
`;
